import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { SecondaryButton } from "../shared/Button";
import { Link } from "react-router-dom";
import Modal from "../shared/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import images from "./galleries.json";
import "./house.css";

function House() {
  let { topicId } = useParams();
  const galleryImages = images[topicId];
  const [isOpenGallery, setIsOpenGallery] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!galleryImages) return;
    const handleKey = (event) => {
      const length = galleryImages.length;
      if (event.key === "ArrowLeft") {
        setIndex((prev) => (prev - 1 + length) % length);
      } else if (event.key === "ArrowRight") {
        setIndex((prev) => (prev + 1) % length);
      }
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [galleryImages]);

  if (!galleryImages) {
    return (
      <div className="container mt-5 pt-5 text-center">
        <p className="mt-5">Project not found.</p>
        <Link to="/portofolio">
          <SecondaryButton text="Back" />
        </Link>
      </div>
    );
  }

  const onOpenGallery = (e) => {
    const currentIndex = e.target.getAttribute("data-index");
    const i = parseInt(currentIndex, 10);
    setIndex(i);
    setIsOpenGallery(true);
  };
  const onCloseGallery = () => {
    setIsOpenGallery(false);
  };

  const nextImage = () => {
    setIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const image = galleryImages.map((src, i) => (
    <div
      key={src}
      className="mt-5 col-sm-12 col-md-6 col-lg-4 d-flex justify-content-center mb-3">
      <div className="" style={{ maxHeight: "250px" }}>
        <img
          src={src}
          className="card-img-top rounded-0"
          alt="portofolio"
          style={{ maxHeight: "250px" }}
          onClick={onOpenGallery}
          data-index={i}
        />
      </div>
    </div>
  ));

  const imageGallery = (
    <img
      src={galleryImages[index]}
      alt="Citi "
      style={{
        alignSelf: "center",
        maxHeight: "100vh",
        maxWidth: "100%",
        justifySelf: "center",
      }}
    />
  );

  return (
    <div className="container">
      <div className="mt-5 pt-5 d-flex align-self-end">
        <Link to="/portofolio">
          <SecondaryButton text="Back" />
        </Link>
      </div>
      {isOpenGallery && <div style={{ height: "100vh" }}></div>}
      {isOpenGallery && (
        <Modal isOpen={isOpenGallery} onClose={onCloseGallery}>
          <div className="gallery-container">
            <FontAwesomeIcon
              icon={["fas", "chevron-circle-left"]}
              className="left"
              size="2x"
              onClick={prevImage}
            />
            {imageGallery}
            <FontAwesomeIcon
              icon={["fas", "chevron-circle-right"]}
              className="right"
              size="2x"
              onClick={nextImage}
            />
          </div>
        </Modal>
      )}
      {!isOpenGallery && <div className="row">{image}</div>}
    </div>
  );
}

export default House;
